import * as THREE from 'three';

/** A picture filling the view behind the part, cropped rather than stretched to the view's shape. */
export class Backdrop {
  private texture: THREE.Texture | null = null;
  private imageAspect = 1;

  constructor(private readonly scene: THREE.Scene, private readonly fallback: THREE.Color) {}

  get shown(): boolean {
    return this.texture !== null;
  }

  set(image: ImageBitmap | null, viewAspect: number): void {
    this.texture?.dispose();
    this.texture = null;
    if (!image) {
      this.scene.background = this.fallback;
      return;
    }
    const texture = new THREE.Texture(image);
    texture.colorSpace = THREE.SRGBColorSpace;
    texture.needsUpdate = true;
    this.texture = texture;
    this.imageAspect = image.width / Math.max(image.height, 1);
    this.scene.background = texture;
    this.fit(viewAspect);
  }

  fit(viewAspect: number): void {
    const texture = this.texture;
    if (!texture) return;
    if (this.imageAspect > viewAspect) {
      texture.repeat.set(viewAspect / this.imageAspect, 1);
    } else {
      texture.repeat.set(1, this.imageAspect / viewAspect);
    }
    texture.offset.set((1 - texture.repeat.x) / 2, (1 - texture.repeat.y) / 2);
  }

  dispose(): void {
    this.texture?.dispose();
    this.texture = null;
  }
}

export const BACKDROP_TYPES = ['image/png', 'image/jpeg', 'image/webp'] as const;
export const BACKDROP_MAX_BYTES = 20 * 1024 * 1024;

// Decoded upright: an ImageBitmap ignores the texture's flipY.
export async function decodeBackdrop(file: Blob): Promise<ImageBitmap> {
  return createImageBitmap(file, { imageOrientation: 'flipY' });
}
